import { Component, OnInit } from '@angular/core';
import { MessageModel } from './core/models/message.model';
import { AppNavigationModel } from './core/models/navigation.model';
import { AuthService } from './core/services/auth/auth.service';
import { MessagingService } from './core/services/messaging.service';
import { NavigationService } from './core/services/navigation.service';
import { NotificationService } from './core/services/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'test-last-angular';

  constructor(
    private message: MessagingService,
    private navigationService: NavigationService,
    private auth: AuthService,
    private notificationService: NotificationService
  ) {
    this.auth.setInit();

    if (this.auth.isAuthenticated()) {
      const appNav = new AppNavigationModel(this.auth.rolCode, this.auth.labelRol);
      this.navigationService.setNavigationModel({
        model: appNav.model!
      });
    }
  }

  ngOnInit(): void {
    try {
      this.message.requestPermission().then((token: string) => {
        localStorage.setItem('token-firebase', token);

        this.message.receiveMessage().subscribe(payload => {
          this.notificationService.addAlert(MessageModel.fromJson(payload))
        }, err => {
          console.log(err);
        });

      }, err => {
        console.log(err);
      });
    } catch (e: any) {
      console.log(e);
      
    }
  }
}
